import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import BrandDiscoveryDevPage from './pages/BrandDiscoveryDevPage';
import BrandDiscoveryDataPage from './pages/BrandDiscoveryDataPage';
import BrandDiscoveryV2Page from './pages/BrandDiscoveryV2Page';
import RedditDataExtractor from './pages/RedditDataExtractor';
import BrandDiscoverySiteImages from './pages/BrandDiscoverySiteImages';

function App() {
  return (
    <BrowserRouter>
      <ToastContainer />
      <Routes>
        <Route path="/bg-test" element={<BrandDiscoveryDevPage />} />
        <Route path="/bg-data" element={<BrandDiscoveryDataPage />} />
        <Route path="/v2-bg-data" element={<BrandDiscoveryV2Page />} />
        <Route path="/reddit" element={<RedditDataExtractor />} />
        <Route path="/site-images" element={<BrandDiscoverySiteImages />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
